<mat-option [class.mat-selected]="allSelected" (click)="toggleSelectAll()">
  <span *ngIf="!allSelected">{{ selectLabel }}</span>
  <span *ngIf="allSelected">{{ deselectLabel }}</span>
</mat-option>

<mat-divider></mat-divider>



// WEBPACK FOOTER //
// ./node_modules/@cicero/webui/lib/core/select-all/select-all.component.html